import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "app-creative-warning-detail-block",
  imports: [],
  template: `
    <div class="flex gap-4">
      <div class="w-[10rem] shrink-0 text-sm font-medium text-neutral-500">{{ title() }}</div>
      <div class="flex">
        <ng-content />
      </div>
    </div>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreativeWarningDetailBlockComponent {
  public readonly title = input.required<string>();
}
